module.exports = __webpack_public_path__ + "img/collection-memoireRingsGold.5bcb22f.webp";